/**
 * LoadingIndicator — visual loading spinner component.
 *
 * LEGACY: slu-frontend/src/common/directives/sluLoadingIndicator.js
 *
 * The AngularJS directive renders an overlay with a CSS spinner and
 * "Loading Content" text. It shows automatically when HTTP requests
 * are pending (via httpRequestTracker).
 *
 * This React equivalent is a presentational component. The visibility
 * logic is controlled by the parent (e.g. isLoading state). The HTML
 * and class names match the legacy template for CSS compatibility.
 *
 * @example
 *   {isLoading && <LoadingIndicator />}
 *   <LoadingIndicator message="Fetching disputes..." />
 */

interface LoadingIndicatorProps {
    /** Custom loading message (default: "Loading Content") */
    message?: string
    /** Whether to show the full-page overlay variant (default: false) */
    overlay?: boolean
}

export function LoadingIndicator({
    message = 'Loading Content',
    overlay = false,
}: LoadingIndicatorProps) {
    if (overlay) {
        return (
            <div className="ux-animated" id="loading-container">
                <div id="loading-overlay"></div>
                <div id="loading-icon-container">
                    <div className="loading-spinner">
                        <div className="loading-spinner-dot1"></div>
                        <div className="loading-spinner-dot2"></div>
                    </div>
                    <h6>{message}</h6>
                </div>
            </div>
        )
    }

    return (
        <div className="slu-loading-indicator">
            <div className="loading-spinner">
                <div className="loading-spinner-dot1"></div>
                <div className="loading-spinner-dot2"></div>
            </div>
            <span>{message}</span>
        </div>
    )
}
